import { Box, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { pxToRem } from "@/util";

export default function Banner() {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Image
        alt="Arel building design"
        src="/images/contact/contactpagehero.png"
        layout="fill"
        objectFit="cover"
        priority
      />

      <Box className={classes.overlay}>
        <Typography className={classes.title}>Contact Us</Typography>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()(() => ({
  container: {
    position: "relative",
    width: "100vw",
    height: pxToRem(377),
    overflow: "hidden",
  },
  overlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
  },
  title: {
    fontSize: pxToRem(48),
    fontWeight: 700,
    color: "#fff",
    fontFamily: "playfair Display",
  },
}));
